import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCalculationStatusTypes } from 'modules/_common/api';
import { getReservationType } from 'modules/accommodations/features/reservations/api';

interface IProps {
  reservationId: string;
  reservationType: string;
}

export const useQueryReservationOverview = ({ reservationId, reservationType }: IProps) => {
  // Fetching reservation statuses
  const {
    error: errReservationStatuses,
    data: dataReservationStatuses,
    isLoading: isLoadingReservationStatuses,
  } = useQuery(QUERY_KEYS.RENTALS_CALCULATION_STATUS_TYPE, getCalculationStatusTypes);

  const {
    error: errReservation,
    data: dataReservation,
    isLoading: isLoadingReservation,
  } = useQuery(
    [QUERY_KEYS.UNITS_RESERVATION_TYPE, reservationId, reservationType],
    () => getReservationType(reservationId as string, reservationType as string),
    { cacheTime: 0, enabled: reservationId && reservationType ? true : false },
  );

  const statusesSelectModel = dataReservationStatuses?.map(item => ({
    value: +item.rootId,
    label: `${item.code} - ${item.label}`,
  }));

  return {
    isLoadingReservationOverview: isLoadingReservationStatuses || isLoadingReservation,
    errReservationOverview: errReservationStatuses || errReservation,
    reservation: dataReservation,
    reservationStatuses: statusesSelectModel,
  };
};
